// Types pour les établissements (Fiches PPMS)
export interface Etablissement {
  id: string;
  submissionId: string;
  nom: string;
  type: string;
  departement: string;
  adresse: string;
  codePostal: string;
  commune: string;
  academie: string;
  submissionTime: string;
}

// Types pour les photos
export interface Photo {
  id: string;
  etablissementId: string;
  categorie: PhotoCategorie;
  sousCategorie?: string;
  legende: string;
  description?: string;
  photoUrl: string;
  photoMetadata?: CloudinaryMetadata; // Métadonnées Cloudinary
  createdAt: string;
  updatedAt: string;
}

// Catégories de photos
export enum PhotoCategorie {
  FACADE = 'Façade',
  SYSTEME_FLUIDE = 'Systèmes de Fluides',
  BATIMENT = 'Bâtiments'
}

// Interface pour l'authentification
export interface User {
  id: string;
  email: string;
  name: string;
  picture?: string;
}

// Interface pour les filtres de recherche
export interface SearchFilters {
  departement?: string;
  typeEtablissement?: string;
  academie?: string;
}

// Interface pour les réponses API Airtable
export interface AirtableResponse<T> {
  records: Array<{
    id: string;
    fields: T;
    createdTime: string;
  }>;
}

// Interface pour les options de formulaire
export interface FormOptions {
  categories: PhotoCategorie[];
  sousCategories: Record<PhotoCategorie, string[]>;
  departements: string[];
  typesEtablissement: string[];
  academies: string[];
}

// Interface pour les erreurs
export interface ApiError {
  message: string;
  code?: string;
  details?: any;
}

// Interface pour les paramètres de pagination
export interface PaginationParams {
  page: number;
  pageSize: number;
  total?: number;
}

// Interface pour les résultats de recherche
export interface SearchResults<T> {
  data: T[];
  pagination: PaginationParams;
  filters: SearchFilters;
}

// Interface pour les métadonnées Cloudinary
export interface CloudinaryMetadata {
  public_id: string;
  width: number;
  height: number;
  format: string;
  created_at: string;
  resource_type: string;
  tags: string[];
  bytes: number;
  type: string;
  etag: string;
  placeholder: boolean;
  url: string;
  secure_url: string;
  signature: string;
  original_filename: string;
} 